/**
 * BaseScene — generic base class for all game scenes.
 *
 * Grabs SceneManager + EventBus from game.registry on init.
 * Creates InputManager, UILayer, GameStateManager on create.
 * Subclasses implement onReady(data?) and onUpdate(time, delta).
 */

declare const Phaser: any;

import { SceneManager } from "./SceneManager";
import { EventBus } from "./EventBus";
import { InputManager } from "./InputManager";
import { UILayer } from "./UILayer";
import { GameStateManager } from "./GameState";
import { AudioManager } from "./AudioManager";
import { AssetManager } from "./AssetManager";
import { FullscreenManager } from "./FullscreenManager";

export abstract class BaseScene extends Phaser.Scene {
  public sm!: SceneManager;
  public bus!: EventBus;
  public audio!: AudioManager;
  public assets!: AssetManager;
  public fullscreen!: FullscreenManager;
  public inputManager!: InputManager;
  public ui!: UILayer;
  public stateManager!: GameStateManager;

  private _sceneData: any;

  init(data?: any): void {
    this.sm = this.game.registry.get("sceneManager");
    this.bus = this.game.registry.get("eventBus");
    this.audio = this.game.registry.get("audio");
    this.assets = this.game.registry.get("assets");
    this.fullscreen = this.game.registry.get("fullscreen");
    this._sceneData = data;
  }

  create(): void {
    this.inputManager = new InputManager(this);
    this.ui = new UILayer(this);
    this.stateManager = new GameStateManager(this);
    this.fullscreen.createButton(this);
    this.onReady(this._sceneData);
  }

  update(time: number, delta: number): void {
    this.inputManager.update();
    this.stateManager.update(time, delta);
    this.onUpdate(time, delta);
  }

  abstract onReady(data?: any): void;
  abstract onUpdate(time: number, delta: number): void;
}
